export default __webpack_public_path__ + "static/media/keto-bars-box.7a4dd930.png";